import { makeStyles, shorthands } from "../shared";

export const dialogStyles = makeStyles({
  dialogRadius: {
    ...shorthands.borderRadius("4px"),
  },
});
